var Linking = require('react-native').Linking;

exports.openURL = function(url) {
  return function() {
    Linking.openURL(url);
  };
};
